module.exports = __webpack_public_path__ + "img/application3.03d3b0ea.png";